import { ElMessage } from 'element-plus'

type Message = typeof ElMessage
let messageInstance: any

const resetMessage: any = (options: any): Message => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = ElMessage(options)
  return messageInstance
}

;['error', 'success', 'info', 'warning'].forEach((type) => {
  resetMessage[type] = (options: any): Message => {
    if (typeof options === 'string') {
      options = {
        message: options,
      }
    }
    options.type = type
    return resetMessage(options)
  }
})

export const message = resetMessage
